import { render } from "./InfoThree.vue?vue&type=template&id=0213c65c&scoped=true"
import script from "./InfoThree.vue?vue&type=script&lang=js"
export * from "./InfoThree.vue?vue&type=script&lang=js"

import "./InfoThree.vue?vue&type=style&index=0&id=0213c65c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0213c65c"]])

export default __exports__